import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
// Montserrat font - self-hosted for faster loading
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
// CSS imports - order matters for cascade:
// 1. Variables (CSS custom properties) must come first
import './styles/_variables.css';
// 2. Tailwind directives + @layer blocks (processed together by PostCSS)
import './index.css';
// 3. Base overrides AFTER Tailwind preflight (fixes border-color: currentColor)
import './styles/_base.css';
// 4. Remaining custom CSS (no @layer, order-independent)
import './styles/_animations.css';
import './styles/_utilities-global.css';
import './styles/_visualizations.css';
import './utils/console-helpers'; // Add console helpers for development
// import { HelmetProvider } from 'react-helmet-async'; // Disabled - causing ref warnings

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
